
export default {
  data() {
    return {
      options: [
        {
          name: "image",
          label: "Slika",
          type: "image",
          size: "590x590",
        },
      ],
      textOptions: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$isInViewport(this.$t("id.ingredients"));
    });
  },
  methods: {
    toggleDescription(e) {
      if (e && e.currentTarget) {
        if (e.currentTarget.classList.contains("active")) {
          e.currentTarget.classList.toggle("active");
        } else {
          const activeElements = document.getElementsByClassName("active");

          if (activeElements && activeElements.length) {
            activeElements.forEach((el) => {
              el.classList.remove("active");
            });
          }
          e.currentTarget.classList.add("active");
        }
      }
    },
  },
};
